import { useTranslations } from 'next-intl';
import {
  HeaderSearchBarSuggestion,
  HeaderSearchBarSuggestionList
} from 'components/pcc-components';
import { useCallback } from 'react';
import { useFormSubmitEvent } from 'hooks/analytics/use-form-submit-event';
import { Image } from 'components/image';
import { useParams } from 'next/navigation';
import { getSeoUrl } from 'utils/links';
import {
  suggestedCategory,
  suggestedKeyword,
  suggestedProducts
} from 'services/searchSuggestions/types';

type SuggestionListProps = {
  searchValue: string;
  suggestedKeyWords: Array<suggestedKeyword>;
  suggestedProducts: Array<suggestedProducts>;
  suggestedCategories: Array<suggestedCategory>;
  isHeadlessCategoryEnabled: boolean;
};

export const SuggestionList = ({
  searchValue,
  suggestedKeyWords,
  suggestedProducts,
  suggestedCategories,
  isHeadlessCategoryEnabled
}: SuggestionListProps) => {
  const t = useTranslations();
  const { fireEvent } = useFormSubmitEvent();
  const params = useParams();
  const seoUrl = getSeoUrl(params);

  const keywordLabel = t('SUGGESTED_KEYWORDS');
  const productLabel = t('SUGGESTED_PRODUCTS');
  const categoryLabel = t('MEQ_SUG_CAT');

  const trackItemSelection = useCallback(
    (displayName: string) => {
      fireEvent({
        formName: 'search',
        formContent: searchValue,
        formContent2: displayName
      });
    },
    [fireEvent, searchValue]
  );

  return (
    <HeaderSearchBarSuggestionList>
      <HeaderSearchBarSuggestion
        label={keywordLabel}
        items={suggestedKeyWords}
        onItemClick={trackItemSelection}
        highlightText={searchValue}
      />
      <HeaderSearchBarSuggestion
        label={productLabel}
        items={suggestedProducts}
        onItemClick={trackItemSelection}
        highlightText={searchValue}
        imgComp={Image}
      />
      <HeaderSearchBarSuggestion
        label={categoryLabel}
        items={suggestedCategories}
        onItemClick={trackItemSelection}
        highlightText={searchValue}
        isHeadlessCategoryEnabled={isHeadlessCategoryEnabled}
        seoURL={seoUrl}
      />
    </HeaderSearchBarSuggestionList>
  );
};
